import { type NonEmptyArray } from '@/packages/JsonQuery';

import { type ILocation, type TLocation } from '@/microfrontends/filters/shared/types/location';

const MOSCOW: ILocation = {
  boundedBy: {
    upperCorner: {
      lat: 56.021224,
      lng: 37.967428,
    },
    lowerCorner: {
      lat: 55.142175,
      lng: 36.803101,
    },
  },
  hasMetro: true,
  hasNeighbors: false,
  displayName: 'Москва',
  name: 'Москва',
  hasHighway: false,
  hasDistricts: true,
  lng: 37.6213,
  lat: 55.7557,
  fullName: 'Москва',
  id: 1,
  parentId: null,
  mainTownId: null,
  hasRegionalDistricts: false,
};

const MOSCOW_REGION: ILocation = {
  boundedBy: {
    upperCorner: {
      lat: 56.958512,
      lng: 40.205688,
    },
    lowerCorner: {
      lat: 54.255696,
      lng: 35.148496,
    },
  },
  mainTownId: 1,
  hasMetro: false,
  hasNeighbors: false,
  displayName: 'Московская область',
  name: 'Московская',
  hasHighway: true,
  hasDistricts: false,
  lng: 37.6213,
  lat: 55.7557,
  fullName: 'Московская область',
  id: 4593,
  parentId: null,
  hasRegionalDistricts: true,
};

const SAINT_PETERSBURG: ILocation = {
  boundedBy: {
    upperCorner: {
      lat: 60.244837,
      lng: 30.759691,
    },
    lowerCorner: {
      lat: 59.633783,
      lng: 29.42981,
    },
  },
  hasMetro: true,
  hasNeighbors: false,
  displayName: 'Санкт-Петербург',
  name: 'Санкт-Петербург',
  hasHighway: false,
  hasDistricts: true,
  lng: 30.3058,
  lat: 59.9385,
  fullName: 'Санкт-Петербург',
  id: 2,
  parentId: null,
  mainTownId: null,
  hasRegionalDistricts: false,
};

const LENINGRAD_REGION: ILocation = {
  boundedBy: {
    upperCorner: {
      lat: 61.329293,
      lng: 35.701312,
    },
    lowerCorner: {
      lat: 58.417336,
      lng: 26.440169,
    },
  },
  mainTownId: 2,
  hasMetro: false,
  hasNeighbors: false,
  displayName: 'Ленинградская область',
  name: 'Ленинградская',
  hasHighway: false,
  hasDistricts: false,
  lng: 30.3058,
  lat: 59.9385,
  fullName: 'Ленинградская область',
  id: 4588,
  parentId: null,
  hasRegionalDistricts: true,
};

/**
 * Временное решение для конвертации `moscow_mo` и `spb_lo` в нормальный вид
 *
 * @export
 * @param {(ILocation | 'moscow_mo' | 'spb_lo')} location
 * @returns {ILocation}
 */
export function tempNormalizeLocation(location: TLocation): NonEmptyArray<ILocation> {
  if (location === 'moscow_mo') {
    return [MOSCOW, MOSCOW_REGION];
  } else if (location === 'spb_lo') {
    return [SAINT_PETERSBURG, LENINGRAD_REGION];
  }

  return [location];
}
